import { create } from 'zustand';

type paymentMethodChangedStore = {
  paymentMethodHasAlreadyBeChanged: boolean;
  setPaymentMethodHasAlreadyBeChanged(value: boolean): void;

  shouldUpdateSale: boolean;
  setShouldUpdateSale(value: boolean): void;

  shouldHideCreditCard: boolean;
  setShouldHideCreditCard(value: boolean): void;

  shouldHideAutomaticDebitAndBilling: boolean;
  setShouldHideAutomaticDebitAndBilling(value: boolean): void;

  showAutoDebtPayment: boolean;
  setShowAutoDebtPayment(value: boolean): void;

  exchangeProhibitedPayment: boolean;
  setExchangeProhibitedPayment(value: boolean): void;

  clearPaymentMethodStores(): void;
};

export const usePaymentMethodChangedStore = create<paymentMethodChangedStore>(
  (set) => ({
    paymentMethodHasAlreadyBeChanged: false,
    setPaymentMethodHasAlreadyBeChanged(value: boolean) {
      set((state) => ({ ...state, paymentMethodHasAlreadyBeChanged: value }));
    },

    shouldUpdateSale: false,
    setShouldUpdateSale(value: boolean) {
      set((state) => ({ ...state, shouldUpdateSale: value }));
    },

    shouldHideCreditCard: false,
    setShouldHideCreditCard(value: boolean) {
      set((state) => ({ ...state, shouldHideCreditCard: value }));
    },

    shouldHideAutomaticDebitAndBilling: false,
    setShouldHideAutomaticDebitAndBilling(value: boolean) {
      set((state) => ({ ...state, shouldHideAutomaticDebitAndBilling: value }));
    },

    showAutoDebtPayment: false,
    setShowAutoDebtPayment(value: boolean) {
      set((state) => ({
        ...state,
        showAutoDebtPayment: value,
      }));
    },

    exchangeProhibitedPayment: false,
    setExchangeProhibitedPayment(value: boolean) {
      set((state) => ({ ...state, exchangeProhibitedPayment: value }));
    },

    clearPaymentMethodStores() {
      set((state) => ({
        ...state,
        paymentMethodHasAlreadyBeChanged: false,
        shouldUpdateSale: false,
        shouldHideCreditCard: false,
        shouldHideAutomaticDebitAndBilling: false,
        showAutoDebtPayment: false,
      }));
    },
  }),
);
